export const GET_HOME_BANNER = "GET_HOME_BANNER";
export const GET_HOME_BANNER_LOADING = "GET_HOME_BANNER_LOADING";
export const GET_HOME_BANNER_SUCCESS = "GET_HOME_BANNER_SUCCESS";
export const GET_HOME_BANNER_ERROR = "GET_HOME_BANNER_ERROR";

export const GET_HOME_COURSE = "GET_HOME_COURSE";
export const GET_HOME_COURSE_LOADING = "GET_HOME_COURSE_LOADING";
export const GET_HOME_COURSE_SUCCESS = "GET_HOME_COURSE_SUCCESS";
export const GET_HOME_COURSE_ERROR = "GET_HOME_COURSE_ERROR";

export const GET_QUESTION_OF_THE_DAY = "GET_QUESTION_OF_THE_DAY";
export const GET_QUESTION_OF_THE_DAY_LOADING =
  "GET_QUESTION_OF_THE_DAY_LOADING";
export const GET_QUESTION_OF_THE_DAY_SUCCESS =
  "GET_QUESTION_OF_THE_DAY_SUCCESS";
export const GET_QUESTION_OF_THE_DAY_ERROR = "GET_QUESTION_OF_THE_DAY_ERROR";

export const CHECK_ALREADY_ANSWERED = "CHECK_ALREADY_ANSWERED";
export const CHECK_ALREADY_ANSWERED_SUCCESS = "CHECK_ALREADY_ANSWERED_SUCCESS";
export const CHECK_ALREADY_ANSWERED_ERROR = "CHECK_ALREADY_ANSWERED_ERROR";
export const CHECK_ALREADY_ANSWERED_CLEAR="CHECK_ALREADY_ANSWERED_CLEAR"

export const CHECK_ANSWER = "CHECK_ANSWER";
export const CHECK_ANSWER_LOADING = "CHECK_ANSWER_LOADING";
export const CHECK_ANSWER_SUCCESS = "CHECK_ANSWER_SUCCESS";
export const CHECK_ANSWER_ERROR = "CHECK_ANSWER_ERROR";
